import _ from 'lodash';
import { IConversation } from 'src/interfaces/conversation';

export const getUniqueSortedConversations = (
    conversations: IConversation[]
): IConversation[] => {
    const conversationsById = _.reduce(
        conversations,
        (acc, conversation) => {
            const currentConversation = acc[conversation._id];
            const currentLastMessage = new Date(
                currentConversation?.lastMessage || 0
            ).getTime();
            const nextLastMessage = new Date(
                conversation.lastMessage
            ).getTime();

            if (!currentConversation || nextLastMessage >= currentLastMessage) {
                acc[conversation._id] = conversation;
            }

            return acc;
        },
        {} as Record<string, IConversation>
    );
    const combinedConversations = Object.keys(conversationsById).map(
        (conversationId) => conversationsById[conversationId]
    );

    return _.orderBy(
        combinedConversations,
        [(item: IConversation) => new Date(item.lastMessage).getTime()],
        ['desc']
    );
};
